import { createEnum } from '../helpers'

/**
 * Credit review event types. Each key identifies a system-detected account change appended to
 * `fuze_credit.review_events`, and names exactly one business rule in
 * `apps/worker/src/review-events/rules`. Events are detected during SAP imports
 *
 * Adding a key here is a compile error until `REVIEW_EVENT_HANDLERS` gains a handler for it, which is
 * what guarantees every event has a defined impact on the system.
 */
export const REVIEW_EVENT_TYPE_KEYS = [
  'failedPaymentCountChanged',
  'creditIndexScoreChanged',
  'centralPayerLinked',
  'centralPayerUnlinked',
  // Open security deposits crossing $0, one key per direction. Moves between two positive amounts
  // are not events.
  'securityDepositsPosted',
  'securityDepositsRefunded',
  'accountDeactivated',
  'accountActivated',
  'newAccount',
] as const

export const REVIEW_EVENT_TYPES = createEnum(REVIEW_EVENT_TYPE_KEYS)
export type ReviewEventTypeKey = (typeof REVIEW_EVENT_TYPE_KEYS)[number]
